import React, { useEffect, useState } from "react";
import axios from "axios";
import { Header } from "../header/Header";
import { Sidebar } from "../sidebar/Sidebar";
import { API_URL } from "../../utils/Url";
import { toast } from "react-toastify";
import "./Contact.css"; // Ensure you create this CSS file to handle formatting

export const Contact = () => {
  const [contactList, setContactList] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = sessionStorage.getItem("token");

  // Fetch data on component mount
  useEffect(() => {
    const getContactData = async () => {
      if (!token) {
        toast.error("Unauthorized. Please log in.");
        setLoading(false);
        return;
      }

      try {
        // Correct way to send authorization headers via Axios
        const { data } = await axios.get(`${API_URL}/api/contact/get-contact`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log(data, "data");
        // Adapt 'data.contacts' based on whatever your backend array field is named
        setContactList(data.data || data || []);
      } catch (err) {
        console.error("Fetch error:", err);
        toast.error("Failed to fetch contact requests");
      } finally {
        setLoading(false);
      }
    };

    getContactData();
  }, [token]);

  return (
    <div className="admin-layout-wrapper">
      {/* Top Persistent Header */}
      <Header />

      <div className="admin-main-container">
        {/* Navigation Sidebar */}
        <Sidebar />

        {/* Safe Scrollable Content Workspace */}
        <div className="blogs-create-page-content">
          <div className="blogs-create-card">
            <div className="card-header">
              <h2 className="page-title">📞 Contact Management</h2>
              <p className="page-subtitle">
                Review incoming user messages and inquiries.
              </p>
            </div>

            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="table-responsive mt-3">
                <table className="table table-hover table-striped align-middle custom-admin-table">
                  <thead className="table-dark">
                    <tr>
                      <th scope="col">Date</th>
                      <th scope="col">Name</th>
                      <th scope="col">Mobile</th>
                      <th scope="col">Email</th>
                      <th scope="col">Message</th>
                    </tr>
                  </thead>
                  <tbody>
                    {contactList.length > 0 ? (
                      contactList.map((item, index) => (
                        <tr key={item._id || index}>
                          <td
                            className="fw-semibold text-muted"
                            style={{ fontSize: "0.9rem" }}
                          >
                            {item.createdAt
                              ? new Date(item.createdAt).toLocaleString()
                              : "N/A"}
                          </td>
                          <td className="fw-semibold">{item.name || "N/A"}</td>
                          <td>{item.mobile || "N/A"}</td>
                          <td>
                            <a
                              href={`mailto:${item.email}`}
                              className="text-decoration-none"
                            >
                              {item.email || "N/A"}
                            </a>
                          </td>
                          <td className="text-muted">
                            {item.desc || "No Message Provided"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center text-muted py-4">
                          No contact inquiries found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
